import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigationHistory } from "@/hooks/useNavigationHistory";
import { getCanonicalUrl } from "@/lib/share";

const setLink = (rel: string, href: string) => {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setMeta = (name: string, content: string) => {
  let el = document.querySelector(`meta[property="${name}"]`) as HTMLMetaElement | null;
  if (!el) el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement("meta");
    if (name.startsWith("og:")) el.setAttribute("property", name);
    else el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const NavigationTracker = () => {
  useNavigationHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    // Baseline canonical is always the clean path. Query parameters (venue
    // ?name/?city hints, ?tab=, ?filter=, tracking params) never identify a
    // distinct indexable page, so they are excluded here; entity pages then
    // refine this with their own slug canonical via usePageMeta.
    const canonical = getCanonicalUrl(pathname);
    setLink("canonical", canonical);
    setMeta("og:url", canonical);
  }, [pathname]);

  return null;
};

export default NavigationTracker;
